// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { baseEnvironment, EnvironmentType } from './environment.base';

export const environment: EnvironmentType = {
  ...baseEnvironment,
  production: false,
  // apiUrl: 'http://localhost:3000'
  apiUrl: 'https://dev-api.kingdombrothersauto.com'
};

export type { EnvironmentType };
